import type { EconSectorCategory } from '../api/chartDataTypes';

export type EconSectorSummary = {
    /** Plain-text version — used by the NVDA live region. */
    text: string;
    /** Same content with the percentage wrapped in <strong> for the visual
     *  banner. Composed entirely from the backend-supplied `sector` and
     *  `display` tokens — no user-controlled input — so the shell can splice
     *  it via dangerouslySetInnerHTML without sanitization. */
    html: string;
};

/**
 * "Information Technology: 34.3 percent."
 *
 * Spells out `percent` in the text variant because NVDA's default punctuation
 * level does not reliably read `%`. The HTML variant uses `%` for visual
 * brevity. Uses the payload's pre-formatted `display` string for the value.
 */
export function buildEconSectorSummarySentence(category: EconSectorCategory): EconSectorSummary {
    return {
        text: `${category.sector}: ${category.display} percent.`,
        html: `${category.sector}: <strong>${category.display}%</strong>.`,
    };
}
